.field {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.label {
  font: var(--t-body-strong);
  color: var(--ink);
}

.control {
  position: relative;
  display: flex;
  align-items: center;
  width: 208px;
}

.input {
  width: 100%;
  height: var(--control-height);
  padding: 0 var(--space-8) 0 var(--space-3);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-control);
  background: var(--paper);
  color: var(--ink);
  font: var(--t-body);
  font-variant-numeric: tabular-nums;
}

.input[data-focused] {
  outline: var(--focus-ring);
  outline-offset: 0;
  border-color: var(--brand);
}

.input[data-invalid] {
  border-color: var(--status-error-fg);
}

.input[data-disabled] {
  background: var(--wash);
  color: var(--pencil);
}

.unit {
  position: absolute;
  right: var(--space-3);
  color: var(--graphite);
  font: var(--t-small);
  pointer-events: none;
}

.description {
  color: var(--graphite);
  font: var(--t-small);
}

.error {
  color: var(--status-error-fg);
  font: var(--t-small);
  font-weight: 600;
}

.visuallyHidden {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}
